import React from "react";
import '../styles/userProfile.css';
import defaultAvatar from "../assets/default-avatar.png";

const UserProfile = ({ avatarUrl, userName = "Guest" }) => {
  return (
    <div className="user-profile">
      <img
        src={avatarUrl || defaultAvatar}
        alt="User Avatar"
        className="user-avatar"
      />
      <span className="user-name">{userName}</span>
    </div>
  );
};

export default UserProfile;